import React from 'react';
import Grid from "@mui/material/Grid";
import { startOfWeek, endOfWeek, tomorrow } from "../../utils/dateFunctions";
import DateSelector from "../../shared/DateSelector";
import Inventory from './Tables/Inventory';
import FormModal from '../../components/FormModal';
import Button from "@mui/material/Button";
import InventoryForm from './Forms/InventoryForm';
import { adalApiFetch } from '../../../adalConfig';
import { dateFormat, textfieldDateFormat, yesterday, dayCompare } from "../../utils/dateFunctions";
import SelectInventoryForm from './Forms/SelectInventoryForm';
import SelectWarehouse from '../../components/SelectWarehouse';
// ❌ remove the shared form
// import RegradeStockForm from './Forms/RegradeStockForm';
// ✅ use the new dedicated frozen form
import FrozenRegradeStockForm from './Forms/FrozenRegradeStockForm';
import TransferStockForm from './Forms/TransferStockForm';
import AdjustQuantityStockForm from './Forms/AdjustQuantityStockForm';
import CreateStockForm from './Forms/CreateStockForm';
import { CircularProgress, ToggleButtonGroup, ToggleButton, Typography } from '@mui/material';

// NEW: import the frozen labeler modal
import FrozenLabelerModal from "./Forms/FrozenLabelerModal";

const InventoryDash = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    const [open, setOpen] = React.useState(false);
    const [openCreate, setOpenCreate] = React.useState(false);
    const [newForm, setNew] = React.useState(false);
    const [rowData, setRowData] = React.useState(null);
    const [reload, setReload] = React.useState(true);
    const [processed, setProcessed] = React.useState(false);
    const [selectedLine, setSelectedLine] = React.useState(false);
    const [warehouse, setWarehouse] = React.useState(null);
    const [date, setDate] = React.useState(new Date());
    const [formType, setFormType] = React.useState(0);

    // NEW: modal state for Create Label
    const [openLabeler, setOpenLabeler] = React.useState(false);

    const reloadFunc = () => {
        setReload(!reload);
    }
    const handleClose = () => {
        reloadFunc();
        setOpen(false);
    }
    const handleCloseCreate = () => {
        reloadFunc();
        setOpenCreate(false);
    }
    const openInvForm = (data) => (row, index) => {
        var selData = data[index.dataIndex];
        setProcessed(selData.stockItem?.isProcessed);
        setOpen(true);
        selData = {
            ...selData,
            processingStatus: 'Not started',
            stockItem: selData.stockItem?.description,
            stockItemId: selData.stockItem?.id,
            amount: selData.portalQuantity,
            supplier: selData.supplier?.name,
        };
        setSelectedLine(selData);
    }

    const openCreateFunc = () => {
        setOpenCreate(true);
    }
    return (
        <React.Fragment>
            <Typography variant={"h1"} mb={0}>Frozen Regrade</Typography>
            <br />
            <br />
            <FormModal open={open} handleClose={handleClose} title={""} fixedWidth>
                <Typography variant="h2" sx={{ mt: 2 }}>Regrade To Frozen</Typography>
                {formType === 0 ? (
                    <FrozenRegradeStockForm
                        processed={processed}
                        access={props.access}
                        handleClose={handleClose}
                        selectedLine={selectedLine}
                        warehouseId={props.location}
                    />
                ) : null}
            </FormModal >
            <Grid container spacing={3.5}>
                <Grid item xs={12}>
                    <Grid item xs={12}>
                        <SelectWarehouse access={props.access} enforceAccess={true} useCache warehouseId={null} state={warehouse} setState={setWarehouse} disabled={false} all />
                        {/* NEW: Create Label button for Frozen only */}
                        <Button
                            variant="contained"
                            sx={{ mt: 2 }}
                            onClick={() => setOpenLabeler(true)}
                            disabled={!warehouse}
                        >
                            Create Label
                        </Button>
                        {/* <Button onClick={openCreateFunc}  variant='outlined'>Create Stock</Button> */}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    {warehouse ? (
                        <SelectInventoryForm
                            reload={reload}
                            onClick={openInvForm}
                            warehouseId={warehouse?.id}
                            access={props.access}
                            hideFrozen
                        />
                    ) : <CircularProgress />}
                </Grid>
            </Grid>

            {/* NEW: Frozen Labeler Modal, scoped to this page */}
            <FrozenLabelerModal
                open={openLabeler}
                onClose={() => setOpenLabeler(false)}
                warehouseId={warehouse?.id}
            />
        </React.Fragment >
    );
};

export default InventoryDash;
